export default `
  <div class="wb-doc-page">
    <div class="doc-main-title">1.活动时间</div>
    <div class="doc-text">2022年9月22日 00:00-2022年10月31日 23:59</div>

    <div class="doc-main-title">2.活动对象</div>
    <div class="doc-text">限特选用户参与</div>

    <div class="doc-main-title">3.奖励规则</div>
    <div class="doc-text doc-pb28">(1).完成首笔入金大于2万港元或以上，30天内无出金记录且30天内交易一次可获得400港元现金奖励;</div>
    <div class="doc-text">(2).完成首笔入金大于10万港元或以上，30天内无出金记录且30天内交易一次可获得1500港元现金奖励;</div>

    <div class="doc-main-title">4.奖励发放及领取</div>
    <div class="doc-text doc-pb28">(1).港股LV2行情需完成新注册、及首笔入金到账后系统自动发放，第二个交易日生效;</div>
    <div class="doc-text">(2).现金奖励券需客户满足入金后30天内未有出金记录且30天内有一笔港股交易的要求，达标后系统会自动发放，逾期无效，不另补发;</div>

    <div class="doc-main-title">5.活动其他条款及细则</div>
    <div class="doc-text doc-pb28">(1).特选用户是指持有中国大陆身份证且常驻地在中国大陆的用户;</div>
    <div class="doc-text doc-pb28">(2).新注册客户可获得30天免费港股行情报价, 首笔入金10万港元或以上的客户可再获得30天免费行情报价,活动期间提供的行情服务，仅限用户在中国大陆使用;</div>
    <div class="doc-text doc-pb28">(3).首笔存入资金为实际完成存入资金的到账金额;</div>
    <div class="doc-text doc-pb28">(4).存入资金必须来自于认可银行的同名个人账户，本公司不接受第叁者账户入金;</div>
    <div class="doc-text doc-pb28">(5).每位客户只能获取一次现金奖励，不可重复;</div>
    <div class="doc-text doc-pb28">(6).如发现包括但不限于通过软件恶意刷奖、手机号码异常、盗取他人信息、邀请人IP异常等行为，盈宝证券有权取消或冻结其活动奖励;</div>
    <div class="doc-text doc-pb28">(7).此活动由盈宝证券国际(香港)有限公司("盈宝证券")提供。本活动并非及不应被视为任何证券、金融产品或工具邀约、要约、招揽、邀请、建议、意见或任何投资决策的见议，亦不应被视为专业意见。浏览本活动的人士在作出任何投资决定之前，应完全了解其风险以及相关法律，涉及的税项及会计的特点及后果，并根据个人的情况决定投资是否适合个人的财政状况及投资目标，以及有关风险的承受能力，有需要时应寻找适当的专业意见。本广告由本公司提供，内容未经香港证券及期货事务监察委员会审阅。盈宝证券保留更改活动条款及细则⼂更改或终止任何优惠的权利，而毋须另行通知。本活动的奖励资格及数据确认以盈宝证券后台数据为準，若有任何争议，盈宝证券保留本活动的最终解释权及决定权，如您有任何疑问，请致电客服热线(852)  2370 9538 或通过在线客服咨询。</div>
  </div>
`
